import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SaleOrderService } from './../sale-order.service';

@Injectable()
export class SaleOrderResolver implements Resolve<any> {
    constructor(
        private saleOrderSvc: SaleOrderService,
    ) { }

    encodeIdParameter(id) {
        if (id.startsWith("#")) {
            return encodeURIComponent(id);
        } else {
            return id;
        }
    }

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        const { id } = route.params;
        const { marketplaceId } = route.queryParams;

        if (marketplaceId) {
            const marketplaceOrderId = this.encodeIdParameter(id);
            return this.saleOrderSvc.getOrderByMarketPlaceId(marketplaceOrderId);
        }
        else {
            return this.saleOrderSvc.getOrderById(id);
        }
    }
}
